import React, { useState } from 'react'
import Layout from '../../components/Layout/Layout'
import styles from './CourierInfo.module.css'
import { Link } from 'react-router-dom'
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import Switch from '../../components/SwitchButton/SwitchButton'

const CourierInfo = () => {
    const [volume, setVolume] = useState(0)

    const handleOnChange = (value) => {
        setVolume(value)
    }
    return (
        <Layout title="Courier Info" route={"/drop-location"}>
            <div className={styles.container}>
                <p>Courier Type</p>
                <div className={styles.btnContainer}>
                    <button>Envelope</button>
                    <button>Box Pack</button>
                    <button>Envelope</button>
                </div>
                <div className={styles.dimensionsContainer}>
                    <div className={styles.dimension}><small>Height</small><p>50 cm</p></div>
                    <div className={styles.dimension}><small>Width</small><p>20 cm</p></div>
                    <div className={styles.dimension}><small>Length</small><p>60 cm</p></div>
                </div>
                <div className={styles.weightContainer}>
                    <div className={styles.weightHeader}>
                        <p>Weight</p>
                        <small>60kg</small>
                    </div>
                    <div className={styles.sliderContainer}>
                        <Slider
                            value={volume}
                            orientation="horizontal"
                            onChange={handleOnChange}
                            labels={{ 0: '9kg', 100: '1000kg' }}
                        />
                    </div>
                </div>
                <div className={styles.frangible}>
                    <p>Frangible?</p>
                    <Switch />
                </div>
                <div className={styles.inputContainer}>
                    <p>Courier detail</p>
                    <textarea placeholder="Enter courier info"></textarea>
                </div>
                <Link to="/confirm-info">
                    <button className={styles.continueBtn}>Continue <i className={styles.icon + " fas fa-long-arrow-alt-down"}></i></button>
                </Link>
            </div>
        </Layout>
    )
}

export default CourierInfo
